import { useCallback } from "react";

export const useScrollToTableTop = () => {
  const scrollToTop = useCallback((query: string) => {
    document.querySelector(query)?.scrollTo({ top: 0, left: 0 });
  }, []);

  return { scrollToTop };
};
